import styled from 'styled-components'

import { RowFlex, FlexCentered } from 'components/common/genericStyles'
import { Color } from 'constants/color'

export const Container = styled.div`
    width: 100%;
    height: 15%;
    ${RowFlex}
    align-items: center;

    & > div {
        margin-right: 10px;
    }
`
export const Filter = styled.div`
    ${FlexCentered}
    min-width: 86px;
    width: max-content;
    height: 40px;
    padding: 4px 16px;
    border-radius: 20px;

    cursor: pointer;

    ${props => {
        const { selected } = props

        const background = selected ? Color.transparentWhite : 'none'
        const border = selected ? Color.transparent : Color.transparentWhite
        const hover = selected
            ? Color.transparentWhite
            : Color.transparentWhite36
        const color = selected ? Color.white : Color.unknownColor24

        return `
            background: ${background}; 
            border: 1px solid ${border};
            & > span {
                color: ${color};
            }
            &:hover {
                background: ${hover};
            }
        `
    }}
    transition: 0.5s ease;
`
